import axios from 'axios';
import CONSTANTS from '../../settings/constants';
import mockEssentials from '../data/essentials';

/* eslint no-console: "off" */
const fetchApps = () => {
  return new Promise(function(resolve) {
    let essentialsApi = CONSTANTS.PARENT_DEFAULT_ESSENTIALS
    //eslint-disable-next-line
    NativeJS.debugLog(`Calling ${essentialsApi}`)
    let start = Date.now()
    axios.get(essentialsApi).then(response => {
      let end = Date.now()
      let time = (end - start) / 1000;
      //eslint-disable-next-line
      NativeJS.debugLog(`${essentialsApi} responded after ${time} seconds with a ${response.status} code`);
      //eslint-disable-next-line
      NativeJS.debugLog(`${essentialsApi} Response body: ${JSON.stringify(response.data, null, 2)}`)
      resolve(response.data)
    }).catch((error) => {
      //eslint-disable-next-line
      NativeJS.debugLog(`error calling ${essentialsApi}: ${JSON.stringify(error, null, 2)}`)
    })
  });
};

/* eslint no-console: "off" */
const fetchEssentialApps = (schoolId) => {
  return new Promise(function(resolve) {
    let essentialsApi = CONSTANTS.SCHOOL_ESSENTIALS + String(schoolId)
    //eslint-disable-next-line
    NativeJS.debugLog(`Calling ${essentialsApi}`)
    let start = Date.now()
    axios.get(essentialsApi).then(response => {
      let end = Date.now()
      let time = (end - start) / 1000;
      //eslint-disable-next-line
      NativeJS.debugLog(`${essentialsApi} responded after ${time} seconds with a ${response.status} code`);
      //eslint-disable-next-line
      NativeJS.debugLog(`${essentialsApi} Response body: ${JSON.stringify(response.data, null, 2)}`)
      resolve(response.data)
    }).catch((error) => {
      //eslint-disable-next-line
      NativeJS.debugLog(`error calling ${essentialsApi}: ${JSON.stringify(error, null, 2)}`)
    })
  });
};

const fetchMockEssentials = () => {
  return new Promise(function (resolve) {
    setTimeout(function () {
      resolve(mockEssentials);
    }, 2000);
  });
}

export default { fetchApps, fetchMockEssentials, fetchEssentialApps }
